export const ROUTER_CONFIG = {
  notFound: '404',
  forbidden: '403',
  auth: {
    login: 'login',
  },
  notifications: 'notifications',
  help: 'help',
  corporateManagement: 'corporate-management'
};
